import React from 'react';

import { LoaderDotsAnimation } from './loader-dots.styled';

export type LoaderDotsProps = {
    /**
     * Number of dots to be displayed.
     */
    totalDots?: number
    /**
     * Size of the dots in a number of pixels.
     */
    dotSize?: number
    /**
     * Spacing between the dots in a number of pixels.
     */
    dotSpacing?: number
    /**
     * The total duration of the animation in seconds.
     */
    duration?: number
};

export const DEFAULT_TOTAL_DOTS = 7;

/**
 * Visual loading indicator which displays a horizontal row of dots and
 * animates their color and size.
 */
export function LoaderDots ({
    totalDots = DEFAULT_TOTAL_DOTS,
    duration = 4,
    dotSize = 10,
    dotSpacing = 15
}: LoaderDotsProps) {
    return (
        <LoaderDotsAnimation
            data-testid={'LoaderDots'}
            totalDots={totalDots}
            dotSize={dotSize}
            dotSpacing={dotSpacing}
            duration={duration}
        >
            {Array.from(Array(totalDots)).map(
                (_, index) => {
                    return (<div key={index} />);
                }
            )}
        </LoaderDotsAnimation>
    );
}
